<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Dealer Registration And Service</li>
		</ol>

        <h1 class="page-header">Dealer Registration And Service</h1>
        <hr>

        <!-- Filter Start -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <div class="col-lg-3 col-xs-12 mb-2">
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Month </label>
                        <select class="form-control w-75" v-model="filter.month">
                            <option v-for="(month, index) in monthList" :value="index+1">{{month}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2">
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Year</label>
                        <select class="form-control w-75" v-model="filter.year">
                            <option v-for="year in yearList">{{year}}</option>
                        </select>
                    </div>
                </div>
                <!-- <div class="col-lg-2 offset-lg-4 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div> -->
            </div>
        </panel>
        <!-- Filter End -->

        <div class="innerBox mt-5">
            <h3 class="text-center">Total Mapping QR Code {{monthList[filter.month-1]}} {{filter.year}}</h3>

            <dealer-table
                :data="data.mapping"
                :maxHeight="400"
            ></dealer-table>
        </div>

        <div class="innerBox mt-5">
            <h3 class="text-center">Total Service QR Code {{monthList[filter.month-1]}} {{filter.year}}</h3>

            <dealer-table
                :data="data.service"
                :maxHeight="400"
            ></dealer-table>
        </div>

    </div>
</template>

<script>
    import qs from 'qs'

    import dealerRegistrationAndServiceTable from './children/dealerRegistrationAndServiceTable'

    export default {
        data () {
            let startYear = 2012;
        
            return {
                yearList : Array(new Date().getFullYear() - startYear+1).fill(startYear).map((year,index) => year + index).reverse(),
                monthList : ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'Desember'],

                filter : {
                    month : new Date().getMonth() + 1,
                    year : new Date().getFullYear(),
                },
                data : {
                    mapping : null,
                    service : null,
                },
            }
        },
        components : {
            dealerTable : dealerRegistrationAndServiceTable
        },
        mounted () {
            this.resetOperation();
        },
        watch : {
            filter : {
                deep : true,
                handler : 'resetOperation'
            }
        },
        methods : {
            resetOperation () {
                this.data.mapping = null;
                this.data.service = null;

                this.getDealerMappingData();
                this.getDealerServiceData();
            },
            getDealerMappingData () {
                this.$http.get(`/api/reports/dealer/register-by-day${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
                .then((resp)=>{
                    this.data.mapping = resp.data.data;
                }).catch((err)=>{console.log(err)})
            },
            getDealerServiceData () {
                this.$http.get(`/api/reports/dealer/service-by-day${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
                .then((resp)=>{
                    this.data.service = resp.data.data;
                }).catch((err)=>{console.log(err)})
            }
        }
    }
</script>

<style scoped>

</style>